<script>
    import I18n from '@js/modules/translations';
    import Computation from '@js/modules/computation';

    const {climbs = []} = $props();

    const CATEGORY_CLASS = {
        hc: 'climb-cat-hc',
        '1': 'climb-cat-1',
        '2': 'climb-cat-2',
        '3': 'climb-cat-3',
        '4': 'climb-cat-4',
        bump: 'climb-cat-bump'
    };
</script>

{#if climbs.length}
    <div class="map-climbs">
        <h3 class="map-climbs-title">
            {I18n.t('js.maps.climbs.title')}
        </h3>

        <ul class="map-climbs-list">
            {#each climbs as climb, index (index)}
                <li class="map-climb">
                    <span class={`climb-cat ${CATEGORY_CLASS[climb.category]}`}>
                        {I18n.t(`js.maps.climbs.category.${climb.category}`)}
                    </span>

                    <span class="climb-stats">
                        <span class="climb-stat">
                            {Computation.formatDistance(climb.length, {smartUnit: true})}
                        </span>
                        <span class="climb-stat">
                            ↑ {Computation.formatDistance(climb.gain, {smartUnit: false, kUnit: false})}
                        </span>
                        <span class="climb-stat">
                            {climb.avgGrade}% {I18n.t('js.maps.climbs.avg')}
                        </span>
                        <span class="climb-stat">
                            {climb.maxGrade}% {I18n.t('js.maps.climbs.max')}
                        </span>
                    </span>
                </li>
            {/each}
        </ul>
    </div>
{/if}
